import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Account } from 'src/app/auth/models/user.model';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopnavComponent implements OnChanges {
  @Input() currentUser!: Account | null;
  @Input() isMobileDevice!: boolean;
  @Input() isExpanded!: boolean;
  @Output() toggleSidebar = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentUser']?.currentValue) {
      this.currentUser = changes['currentUser']?.currentValue;
    }
  }
}
